import { ContractPropertyName } from '../../../constants';
import { IsTransactionHelperBase } from './IsTransactionHelperBase';
export class IsProcessedTransactionHelper extends IsTransactionHelperBase {
    constructor() {
        super(...arguments);
        this.prefix = ContractPropertyName.processedTransactions;
    }
}

//# sourceMappingURL=IsProcessedTransactionHelper.js.map
